import { create } from 'zustand';

/**
 * Estado do popup do chat interno — GLOBAL (zustand) porque o hook de
 * notificações precisa saber se a thread do remetente está aberta pra
 * decidir entre "auto-lido em silêncio" e "som + badge".
 */
interface InternalChatState {
  open: boolean;
  /** Colega com a thread aberta (null = visão de lista). */
  activePeerId: number | null;
  /** Lightbox de imagem aberto — o Esc do POPUP fica mudo enquanto true
   *  (senão um Esc fecha lightbox E popup juntos). */
  lightboxOpen: boolean;
  /** Posição do popup quando o usuário ARRASTOU (fixed, px). null = ancorado
   *  no padrão (canto sup. direito). Vale enquanto ABERTO — fechar reseta
   *  (decisão do dono: reabrir sempre ancorado no ícone). */
  pos: { x: number; y: number } | null;
  setOpen: (open: boolean) => void;
  openThread: (peerId: number) => void;
  backToList: () => void;
  setLightboxOpen: (v: boolean) => void;
  setPos: (p: { x: number; y: number } | null) => void;
}

export const useInternalChatStore = create<InternalChatState>((set) => ({
  open: false,
  activePeerId: null,
  lightboxOpen: false,
  pos: null,
  setOpen: (open) =>
    set(open ? { open } : { open, activePeerId: null, lightboxOpen: false, pos: null }),
  openThread: (peerId) => set({ open: true, activePeerId: peerId }),
  backToList: () => set({ activePeerId: null, lightboxOpen: false }),
  setLightboxOpen: (v) => set({ lightboxOpen: v }),
  setPos: (p) => set({ pos: p }),
}));
